import {isEmpty} from 'lodash'

import {DEFAULT_FORMAT_CHARS} from './consts'
import {FormatChars, MaskData, PhoneMask} from './types'

const parseOnlyNumbers = (str: string) => str.replace(/\D/g, '')
const parseNumbersAndPlus = (str: string) => str.replace(/[^\d+]/, '')
const removeInvalidCharacters = (input: string) =>
  input.length > 1 ? parseNumbersAndPlus(input[0]) + parseOnlyNumbers(input.substr(1)) : parseNumbersAndPlus(input)

const addPlus = (phone: string) => {
  if (phone === '') {
    return phone
  }
  return phone[0] === '+' ? phone : `+${phone}`
}

const findRegionCodeWithMask = (input: string, masks: PhoneMask): string | undefined => {
  if (!masks) {
    return
  }

  let currentValue = ''
  let code: string

  input.split('').forEach(num => {
    currentValue += num
    code = masks[currentValue] ? currentValue : code
  })

  return code
}

// функция возвращает маску по самому длиному коду региона который сможет найти в инпуте
const getMask = (value: string, int18Masks: PhoneMask = {}, localMasks: PhoneMask = {}): MaskData | undefined => {
  const parsedPhone = parseOnlyNumbers(value)
  const hasMasks = int18Masks || localMasks

  if (!parsedPhone || !hasMasks) {
    return {mask: undefined, needAddPlus: undefined}
  }

  const localCode = !value.includes('+') ? findRegionCodeWithMask(parsedPhone, localMasks) : undefined
  const int18Code = findRegionCodeWithMask(parsedPhone, int18Masks)

  let mask: string = undefined

  if (localCode && int18Code) {
    mask = localCode.length >= int18Code.length ? localMasks[localCode] : int18Masks[int18Code]
  } else {
    mask = localMasks[localCode] || int18Masks[int18Code]
  }

  return {
    mask,
    needAddPlus: !!int18Code,
  }
}

const applyMaskToPhone = (parsedPhone: string, formatChars: FormatChars, mask?: string) => {
  if (!mask || isEmpty(parsedPhone)) {
    return parsedPhone
  }

  const phoneArray = parsedPhone.split('')
  const maskArray = mask.split('')

  let result = ''
  const formatCharsKeys = Object.keys(formatChars)
  while (phoneArray.length > 0 && maskArray.length > 0) {
    const char = maskArray.shift()

    if (formatCharsKeys.includes(char)) {
      const formatCharsValue = formatChars[char]
      const regexp = new RegExp(formatCharsValue)
      let phoneChar = phoneArray.shift()

      while (phoneChar && !phoneChar.match(regexp)) {
        phoneChar = phoneArray.shift()
      }
      phoneChar && (result += phoneChar)
    } else {
      result += char
    }
  }
  return result
}

export const formatPhoneNumber = (
  phone: string,
  formatChars: FormatChars = DEFAULT_FORMAT_CHARS,
  int18Masks?: PhoneMask,
  localMasks?: PhoneMask,
) => {
  // 8absde&999er+32 -> 899932
  const parsedPhone = removeInvalidCharacters(phone)
  // для 899932 находит маску из переданных масок: int18Masks(для телефонов с + в начале) и localMasks(телефонов без + в начале) -> # (###) ###-##-##
  const {mask, needAddPlus} = getMask(parsedPhone, int18Masks, localMasks)
  // добавляет плюс в начало строки если нашлась маска из int18Masks, пример для РФ: 7925 -> +7925
  const parsedPhoneWithLeadingPlus = needAddPlus ? addPlus(parsedPhone) : parsedPhone

  // совмещает !(уже профильтрованный) инпут с маской, для ("899932", "# (###) ###-##-##") -> 8 (999) 32

  return applyMaskToPhone(parsedPhoneWithLeadingPlus, formatChars, mask)
}

export const getAppliedMask = (phone: string, int18Masks?: PhoneMask, localMasks?: PhoneMask) => {
  const parsedPhone = removeInvalidCharacters(phone)
  const maskData = getMask(parsedPhone, int18Masks, localMasks)

  return maskData
}
